//#region Asset Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/gallery'
import 'devextreme/ui/load_indicator'

//#endregion

import { $SCOPE_SERVICE_NAME } from '../../../services/system'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

import { Api } from '../../api/api.module'
import { GalleryDirectiveController } from './gallery.directive.controller'

//#region Asset Imports

import './gallery.scss'
import * as TEMPLATE from './gallery.tpl.html'

//#endregion

export class GalleryDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        schemas: '=',
        disableRefresh: '=',
        referenceType: '=?',
        correlationType: '=?',
        eventNameForSchemaChanged: '=?',
        schemaOwner: '='
    }
    template = TEMPLATE

    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            $scope,
            userSession: UserSessionService
        ) => new GalleryDirectiveController($scope, userSession)]
}